import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { CaseService } from 'src/app/services/case.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { ApplicationDocumentDto } from './dto/application-document.dto';
//import {FileUploadModule} from 'primeng/fileupload';

@Component({
    selector: 'app-case-docs',
    templateUrl: './case-docs.component.html'
})
export class CaseDocsComponent implements OnInit {

    @Input() caseId: string;
    @Input() userRole: string;
    @Output() changeEvent = new EventEmitter();

    myDocs: ApplicationDocumentDto[] = [];
    myDocument: ApplicationDocumentDto;
    myDelDocId: any;    // ID of document to be deleted

    myFiles: any[] = [];
    myFile: File;
    uploadedFiles: any[] = [];
    selectedFiles: any[] = [];

    documentTypeChoiceList: [];
    cols: any[];

    displayState: any = {
        addDocumentDiv: false,
    }

    allowUpload: boolean = false;
    allowDelete: boolean = false;

    constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
        private messageService: MessageService, private confirmationService: ConfirmationService) { }

    ngOnInit() {
        // set permission flags based on user role
        this.setAllowFlags();
        // GET Minutes data for this application
        this.cols = [
            { field: 'typeOfAttachmentId', header: 'Document Type' },
            { field: 'description', header: 'Description' },
        ];
        let dicts = this.dictService.getDictionaries();
        this.documentTypeChoiceList = dicts.documentTypes;
        this.utilService.doAudit(this.caseId,'Docs; getting case:');
        // console.log('Docs; getting case: ' + this.caseId);
        this.myDocs = [];  // initialize array so it is defined and does not generate an error in the template
        if (this.caseId) {
            this.getCaseDocs();
        }
    }

    addDragDrop() {
        // alert('adding drag and drop capabilities');
        const target = document.getElementById('uploadFiles');

        target.addEventListener('drop', (e) => {
          e.stopPropagation();
          e.preventDefault();

          this.dragFiles(e.dataTransfer.files);
        });

        target.addEventListener('dragover', (e) => {
          e.stopPropagation();
          e.preventDefault();

          e.dataTransfer.dropEffect = 'copy';
        });
        // alert('done w/ drag and drop');

    }

    dragFiles(files: any) {
        this.utilService.doAudit(files, 'dragFiles:');
        alert('dropped some files??');
    }

    myUploader(event) {
        this.utilService.doAudit(event.files, 'myUploader event:');
        const numFiles = event.files.length;
        for(let file of event.files) {
            this.uploadedFiles.push(file);
            this.myFile = file;
        }
        this.utilService.doAudit(this.uploadedFiles, 'uploaded files array:');
        this.caseService.saveCaseDocument(this.caseId, this.uploadedFiles, this.myDocument).subscribe(data => {
            this.utilService.doAudit(data, 'returned by saveCaseDocument method:');
            this.showToast({ key: 'infoDoc', severity: 'info', detail: 'Document Uploaded', summary: 'Info' });
            this.getCaseDocs();
            this.cancelAddDoc();
        });
    }

    onUpload(event) {
        this.utilService.doAudit(event, 'onUpload event:');
        alert('onUpload event triggered');
        for(let file of event.files) {
            this.uploadedFiles.push(file);
        }
        this.messageService.add({key: 'infoDoc', severity: 'info', summary: 'File Uploaded', detail: ''});
    }
    onError(event) {
        this.utilService.doAudit(event, 'onError event:');
    }
    showProgress(event) {
        this.utilService.doAudit(event, 'showProgress event:');
    }
    showComplete(event) {
        this.utilService.doAudit(event, 'showComplete event:');
    }
    // view document
    viewDoc2(myDoc: any) {
      this.displayState.workingDiv = true;
      this.utilService.doAudit(myDoc, 'myDoc:');
      let docUrl = this.caseService.getCaseDoc(myDoc.id).subscribe(data => {
        this.utilService.doAudit('got response from getCaseDoc:');
        if (data) {
          // const myBlob = new Blob(myData, {type: 'application/pdf'} );
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
          this.displayState.workingDiv = false;
        } else {
          this.showToast({ key: 'toast', severity: 'error', detail: 'Problem retrieving document; try again', summary: 'Warning' });
          this.displayState.workingDiv = false;
        }
      });
    }
  viewDoc(myDoc: any) {
    this.displayState.workingDiv = true;
    this.utilService.doAudit(myDoc, 'myDoc:');
    let docUrl = this.caseService.getCaseDoc(myDoc.id).subscribe(data => {
      this.utilService.doAudit(data,'got response from getCaseDoc:');
      if (data) {
        // const myBlob = new Blob(myData, {type: 'application/pdf'} );
        const myUrl = URL.createObjectURL(data);
        window.open(myUrl, '_blank');
        URL.revokeObjectURL(myUrl);
        this.displayState.workingDiv = false;
      } else {
        this.showToast({ key: 'toast', severity: 'error', detail: 'Problem retrieving document; try again', summary: 'Warning' });
        this.displayState.workingDiv = false;
      }
    },
      error => {
      this.utilService.doAudit(error,'Error:');
        this.showToast({ key: 'toast', severity: 'error', detail: 'Unable to retrieve document!', summary: 'Warning' });
        this.displayState.workingDiv = false;
    });
  }

    addDoc() {
        // **** NOTE: there seems to be a problem w/ this DTO; the API can not serialize it, as per Jep; might be the creationDate field value??
        //this.myDocument = new ApplicationDocumentDto();
        this.myDocument = {
            id: 0,
            applicationId: Number(this.caseId),
            description: '',
            descriptionOther: '',
            documentName: '',
            documentLocation: '',
            creationDate: new Date(),
        };
        //this.myDocument.applicationId = Number(this.caseId);
        this.utilService.doAudit(this.myDocument, 'myDocument');
        this.displayState.addDocumentDiv = true;
    }

    cancelAddDoc() {
        this.uploadedFiles = [];
        this.myDocument = new ApplicationDocumentDto();
        this.displayState.addDocumentDiv = false;
    }

    setAllowFlags() {
        if (this.userRole.includes('Clerk') || this.userRole.includes('Administrator')) {
            this.allowUpload = true;
            this.allowDelete = true;
        }
        else {
            this.allowUpload = false;
            this.allowDelete = false;
        }

    }
    // determine if user is an "administrator", and has certain privileges, i.e. able to delete documents, etc
    isAdministrator() {
        if (this.userRole.includes('Clerk') || this.userRole.includes('Administrator')) { return true }
        else if (this.userRole.includes('ReadOnly')) { return false }
        else { return false }
    }

    getCaseDocs() {
        // FOR TESTING:  use caseId = 7180, 6137, 6128
        this.caseService.getCaseDocs(this.caseId).subscribe(data => {
            this.utilService.doAudit(data, 'docs:');
            let n = data.length;
            let xDate: any;
            for (let i=0; i<n; i++){
                //console.log(response[i].statusDate);
                xDate = data[i].creationDate;
                if (xDate != null) {
                    xDate = xDate.slice(0,10) + 'T10:00:00';
                    data[i].creationDate = xDate;
                }
            }
            this.utilService.doAudit(data, 'processed docs:');
            this.myDocs = data;
            this.dataChange();  // emit event so Parent component is alerted of change in data
        });
    }
    // this method executed whenever any data in the component is changed; it should trigger an event defined on the PARENT component
    dataChange() {
        this.utilService.doAudit(this.myDocs, 'documents data changed');
        this.changeEvent.emit(this.myDocs);
    }

    deleteDoc(myDoc: any) {
        this.myDelDocId = myDoc.id;
        this.showConfirm('Do you want to DELETE this document?');
    }

    deleteDocConfService(myDoc: any) {
        this.confirmationService.confirm({
            message: 'Do you want to DELETE this Document?',
            header: 'Deleting Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.caseService.deleteCaseDoc(myDoc.id).subscribe(data => {
                    this.utilService.doAudit(data, 'returned from deleteCaseDoc:');
                    this.showToast({ key: 'infoDoc', severity: 'success', detail: 'Document Deleted', summary: 'Info' });
                    this.getCaseDocs();
                });
            },
            reject: () => {
                this.showToast({ key: 'toast', severity: 'info', detail: 'No action performed.', summary: ''});
            }
        });
    }

    // TOAST related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
    }

    showConfirm(msgDetails: string) {
    this.messageService.clear();
    this.messageService.add({key: 'confDoc', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: msgDetails});
    }


    onConfirm() {
        this.utilService.doAudit('hit onConfirm');
        if ( !this.myDelDocId) {
            this.showToast({ key: 'toast', severity: 'error', detail: 'Nothing done!', summary: 'Missing Document ID' });
            return;
        }
        // else, continue...
        this.caseService.deleteCaseDoc(this.myDelDocId).subscribe(data => {
            this.utilService.doAudit(data, 'returned from deleteCaseDoc:');
            this.showToast({ key: 'infoDoc', severity: 'success', detail: 'Document Deleted', summary: 'Info' });
            this.getCaseDocs();
        });
        this.messageService.clear('confDoc');
    }

    onReject() {
        this.utilService.doAudit('hit onReject');
        this.messageService.clear('confDoc');
    }

    clear() {
    this.messageService.clear();
    }

}
